// T015 — Upcoming credit-batch expirations panel.
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { sourceProgramLabel } from "../consts";
import { formatEur } from "../../../utils/eur";
import { formatDate } from "../../../utils/formats";
import type { UpcomingExpiration } from "../../../types/wallet";

interface UpcomingExpirationsListProps {
  expirations: UpcomingExpiration[];
}

const truncateBatchId = (batchId: string) => {
  if (!batchId) return "—";
  return batchId.length > 12 ? `${batchId.slice(0, 8)}…` : batchId;
};

const UpcomingExpirationsList = ({ expirations }: UpcomingExpirationsListProps) => {
  if (!expirations || expirations.length === 0) {
    return (
      <Card title="Upcoming expirations">
        <p className="text-color-secondary m-0">No active credit batches.</p>
      </Card>
    );
  }

  return (
    <Card title="Upcoming expirations">
      <DataTable value={expirations} size="small" emptyMessage="No active credit batches.">
        <Column header="Batch" body={(row: UpcomingExpiration) => truncateBatchId(row.batch_id)} />
        <Column field="source_program" header="Source program" body={(row: UpcomingExpiration) => sourceProgramLabel(row.source_program) ?? "—"} />
        <Column header="Amount" body={(row: UpcomingExpiration) => formatEur(row.amount)} />
        <Column header="Expires" body={(row: UpcomingExpiration) => formatDate(row.expires_at)} />
      </DataTable>
    </Card>
  );
};

export default UpcomingExpirationsList;
